import EditorContentContainer from './container/Editor.Content.Container';
import EditorContentImage from './image/Editor.Content.Image';
import EditorContentParagraph from './typography/paragraphs/Editor.Content.Paragraph';
import EditorContentQR from './qr/Editor.Content.QR';
import EditorContentLauncher from './launcher/Editor.Content.Launcher';

const editorResolvers = {
  EditorContentContainer,
  EditorContentParagraph,
  EditorContentImage,
  EditorContentQR,
  EditorContentLauncher,
};

export default editorResolvers;
